import { motion } from 'framer-motion'
import dispatchlyImg from '@/assets/images/dispatchly.webp'
import sprintoImg from '@/assets/images/sprinto.webp'
import planImg from '@/assets/images/voca.webp'

const products = [
  {
    id: 1,
    image: dispatchlyImg,
    name: 'Dispatchly',
    description:
      'A platform for managing and optimizing dispatch operations in logistics and transport.',
    href: 'https://dispatchly-landing.vercel.app/',
  },
  {
    id: 2,
    image: sprintoImg,
    name: 'Sprinto',
    description:
      'A platform to Manage projects, milestones, QA, collaboration, analytics, and AI agents from one connected workspace.',
    href: 'https://sprinto-landing-steel.vercel.app/',
  },
  {
    id: 3,
    image: planImg,
    name: 'Voca',
    description:
      'VOCA engages customers across every channel, qualifying leads and moving conversations forward automatically',
    href: 'https://voca.codefied.co/',
  },
]

export function ProductsSection() {
  return (
    <section
      id="products"
      className="bg-white pt-12 sm:pt-16 md:pt-20 lg:pt-[200px]"
      aria-label="Our Products"
    >
      <div className="container-site">
        {/* Header row */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between lg:gap-0"
        >
          {/* Left: label + heading */}
          <div className="flex flex-col gap-3 sm:gap-4 lg:gap-5">
            <span className="font-sans text-[13px] font-bold not-italic uppercase tracking-[0.061px] text-[#D4575B] sm:text-[15px] lg:text-[18px]">
              Our Products
            </span>
            <h2 className="max-w-[953px] font-sans text-[26px] font-medium not-italic leading-[30px] tracking-[-0.5px] sm:text-[34px] sm:leading-[38px] md:text-[40px] md:leading-[44px] lg:text-[48px] lg:leading-[55px] lg:tracking-[-1px]">
              <span className="text-[#2D2D2D]">Built, Launched, and Scaled.</span>{' '}
              <span className="text-[#979AC0]">
                Products designed to perform beyond development, built for real-world use and scale.
              </span>
            </h2>
          </div>

          {/* Right: CTA button */}
          {/* <div className="shrink-0">
                        <a
                            href="#"
                            className="inline-flex items-center justify-center gap-[10px] rounded-[10px] border border-[rgba(41,41,41,0.09)] bg-[#302F2F] p-4 text-center font-sans text-[18px] font-normal not-italic leading-normal text-white transition-colors hover:bg-black"
                            style={{ leadingTrim: 'both', textEdge: 'cap' } as React.CSSProperties}
                        >
                            See More Projects
                        </a>
                    </div> */}
        </motion.div>

        {/* Cards grid */}
        <div className="flex flex-col gap-5 md:flex-row md:flex-wrap md:items-start lg:flex-nowrap lg:justify-center">
          {products.map((product, i) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex w-full flex-col md:w-[calc(50%-10px)] lg:w-0 lg:flex-1 min-[1440px]:w-[396.603px] min-[1440px]:flex-none"
            >
              <a
                href={product.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col"
              >
                {/* Image */}
                <div className="mb-5 overflow-hidden rounded-[9.841px] w-full h-[260px] sm:h-[300px] md:h-[340px] lg:h-[420px] min-[1440px]:h-[466.476px]">
                  <img
                    src={product.image}
                    alt={product.name}
                    className=" w-full h-full object-cover object-top transition-transform duration-500 hover:scale-[1.04]"
                  />
                </div>

                {/* Text */}
                <div className="flex flex-col gap-[13px]">
                  <h3 className="font-sans text-[23.619px] font-medium not-italic leading-[21.285px] text-[#292929]">
                    {product.name}
                  </h3>
                  <p className="font-sans text-[14.19px] font-normal not-italic leading-[19.954px] text-black">
                    {product.description}
                  </p>
                  <span className="mt-1 inline-flex items-center gap-[10px] font-sans text-[14.19px] font-normal not-italic leading-[19.954px] text-[#D4575B] transition-gap group-hover:gap-[15px]">
                    View this product
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                    >
                      <path
                        d="M0.984375 0.984123L5.15967 5.15942C5.544 5.54375 5.544 6.16686 5.15967 6.55119L0.984375 10.7265"
                        stroke="#D4575B"
                        strokeWidth="1.96825"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
